import queryString from 'query-string'

export const fetchAddress = (params: { [key: string]: string }) => {
  const queryParams = queryString.stringify(params)

  return fetch('https://amk.viss.gov.lv/rest/address?' + queryParams).then((resp) => resp.json())
}
